import { render } from "./ShipmentFilesPane.vue?vue&type=template&id=2bea522e&ts=true"
import script from "./ShipmentFilesPane.vue?vue&type=script&lang=ts"
export * from "./ShipmentFilesPane.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__